import { render, staticRenderFns } from "./EditBollettino.vue?vue&type=template&id=287d4a38"
import script from "./EditBollettino.vue?vue&type=script&lang=js"
export * from "./EditBollettino.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports